export function Vr() {
  return <div style={{ borderLeft: '1px solid #DBDBDB' }} />;
}

export default Vr;
